'use client';

import { SORT_KEYS, SORT_LABELS, type Sort } from '@ria-client/advisor-search/constants';
import { Button } from '@ria-client/tw-shadcn/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@ria-client/tw-shadcn/components/dropdown-menu';

import { SortIcon } from '../icons';

export interface ResultsSortMenuProps {
  currentSort: Sort;
  onSortChange: (sort: Sort) => void;
  isLoading?: boolean;
}

export function ResultsSortMenu({
  currentSort,
  onSortChange,
  isLoading = false,
}: ResultsSortMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          fullWidth={false}
          disabled={isLoading}
          className="h-[34px] w-[200px] rounded-full border-border bg-background px-5 py-0 font-semibold normal-case hover:border-foreground hover:bg-background"
        >
          <SortIcon className="size-5 -ml-1" />
          {SORT_LABELS[currentSort]}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SORT_KEYS.map(key => (
          <DropdownMenuItem
            key={key}
            data-selected={key === currentSort}
            onSelect={() => onSortChange(key)}
            className="data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground"
          >
            {SORT_LABELS[key]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
